<script setup>
import { ref } from "vue";
import { Head, useForm, Link } from "@inertiajs/vue3";
import Input from "@pages/Shared/form/Input.vue";
import Button from "@pages/Shared/form/Button.vue";
import { PhEye, PhEyeClosed } from "@phosphor-icons/vue";
import Spinner from "@pages/Shared/ui/Spinner.vue";
import logo from '@/../images/logo.jpg';
import { useLoader } from '@/Stores/useLoader';
import { flashToast } from "@/toast.js";

const form = useForm({ password: "", password_confirmation: "" });
const showPassword = ref(false);
const loader = useLoader();

const submit = () => {
  form.post("/update-password", {
    onSuccess: (page) => {
      loader.start();
      setTimeout(() => {
        if (page.props.flash) flashToast(page.props.flash);
      }, 500);
    },
  });
};
</script>

<template>
  <Head title="Update Password" />

  <div class="min-h-screen w-full flex items-center justify-center bg-background px-4">
    <div class="w-full max-w-sm">
      <div class="bg-white rounded-lg border border-gray-300 px-8 py-10">

        <div class="flex justify-center mb-6">
          <img :src="logo" alt="Logo" class="w-20 h-20 object-contain" />
        </div>

        <div class="text-center mb-7">
          <h1 class="text-2xl font-bold text-[#0f1929] tracking-tight">Update Password</h1>
          <p class="mt-1.5 text-sm text-gray-500">Enter your new password and confirm it</p>
        </div>

        <form @submit.prevent="submit" class="flex flex-col gap-5">

          <div class="relative">
            <Input
              v-model="form.password"
              :error="form.errors.password"
              label="Password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="xxxxxxxx"
            />
            <button
              type="button"
              @click="showPassword = !showPassword"
              tabindex="-1"
              aria-label="Toggle password visibility"
              class="absolute right-3 top-[2.1rem] text-gray-400 hover:text-gray-600 transition-colors"
            >
              <component :is="showPassword ? PhEyeClosed : PhEye" :size="20" />
            </button>
          </div>

          <div class="relative">
            <Input
              v-model="form.password_confirmation"
              :error="form.errors.password_confirmation"
              label="Confirm Password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="xxxxxxxx"
            />
            <button
              type="button"
              @click="showPassword = !showPassword"
              tabindex="-1"
              aria-label="Toggle password visibility"
              class="absolute right-3 top-[2.1rem] text-gray-400 hover:text-gray-600 transition-colors"
            >
              <component :is="showPassword ? PhEyeClosed : PhEye" :size="20" />
            </button>
          </div>

          <Link href="/login" class="text-xs text-primary underline underline-offset-2 hover:opacity-80 transition-opacity">
            Back to Login
          </Link>

          <Button
            type="submit"
            :disabled="form.processing"
            class="w-full py-2.5 bg-primary hover:bg-primary-light text-white font-semibold rounded-lg transition-colors flex justify-center items-center gap-2 cursor-pointer disabled:opacity-70 shadow-sm"
          >
            <Spinner v-if="form.processing" :size="16" color="white" />
            <span>{{ form.processing ? 'Updating…' : 'Update Password' }}</span>
          </Button>

        </form>

        <p class="mt-8 text-center text-xs text-gray-400">
          &copy; {{ new Date().getFullYear() }} Bn Mas'ud College. All rights reserved.
        </p>

      </div>
    </div>
  </div>
</template>